import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import ImagesWithZoom from '@/shared/components/ui/Images/ImagesWithZoom';
import { useDeletePhoto } from '../actions/noc-module.actions';
import { toast } from 'react-toastify';

interface ListaImagenProps {
    itemData: any[];
    refetch: () => void;
}

export default function ListaImagen({
    itemData,
    refetch,
}: ListaImagenProps) {

    const useDeletePhotoMutation = useDeletePhoto();

    const deleteFile = async (id: string) => {
        useDeletePhotoMutation.mutate(id, {
            onSuccess: async () => {
                toast.success("Foto eliminada correctamente");
                refetch();
            },
            onError: (error) => {
                toast.error("Error al eliminar la foto");
                console.error(error);
            }
        });
    };

    return (
        <ImageList sx={{ width: '100%', height: 250 }} cols={4} >
            {itemData.map((item) => (
                <ImageListItem key={item.img} sx={{ width: '100%', height: '50px' }} >
                    <ImagesWithZoom
                        src={`${item.img}`}
                        alt={item.title}
                    />
                    <ImageListItemBar
                        title={item.title}
                        subtitle={item.author}
                        actionIcon={
                            <>
                                {item.status === 'PENDIENTE' ? (
                                    <IconButton
                                        sx={{ color: 'rgba(236, 36, 36, 0.54)' }}
                                        aria-label={`delete ${item.title}`}
                                        onClick={() => deleteFile(item.id)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                ) : null}
                            </>
                        }
                    />
                </ImageListItem>
            ))}
        </ImageList>
    );
}